import React from 'react';
import { Picture } from '@cx-web/components/primitives/Picture';
import { formatLinkProperties } from '@cx-web/utils/formatLinkProperties';

import begambleaware from './img/compliance/begambleaware.svg';
import gamblingtherapy from './img/compliance/gambling-therapy.svg';
import gamstop from './img/compliance/gamstop.svg';
import raigSvg from './img/compliance/raig.svg';
import instagram from './img/social/instagram.svg';
import twitter from './img/social/twitter.svg';
import youtube from './img/social/youtube.svg';
import styles from './FooterWS.module.css';

const standardLinks = [
  {
    title: 'About Us',
    href: 'https://www.whoscored.com/aboutus',
  },
  {
    title: 'Privacy Policy',
    href: 'https://www.whoscored.com/privacy',
  },

  {
    title: 'Contact Us',
    href: 'https://www.whoscored.com/contactus',
  },
  {
    title: 'Terms of Use',
    href: 'https://www.whoscored.com/termsofuse',
  },
];

export const FooterWS = ({ resourcesUrl }: { resourcesUrl: string }): JSX.Element => {
  const links = [...standardLinks];

  return (
    <section className={styles.footerContainer} data-testid="footer-oc">
      <div className={`container ${styles.footerWrapper}`}>
        <div className={styles.footerCenter}>
          <a data-testid="ws-logo-link" {...formatLinkProperties('https://www.whoscored.com/')}>
            <Picture
              altText="whoscored logo"
              className={styles.footerLogoLink}
              pngSrc={`${resourcesUrl}/assets/img/ws-logo.png`}
            />
          </a>
          <div className={styles.footerLinksWrapper}>
            <div className={styles.socialLogosWrapper} data-testid="social-logos">
              <a
                href="https://www.instagram.com/officialwhoscored"
                rel="noopener noreferrer"
                target="_blank"
                title="Instagram"
              >
                <Picture
                  altText="instagram icon"
                  className={styles.socialIcon}
                  height={40}
                  svgSrc={instagram}
                  width={40}
                />
              </a>
              <a href="https://twitter.com/WhoScored" rel="noopener noreferrer" target="_blank" title="Twitter">
                <Picture altText="twitter icon" className={styles.socialIcon} height={40} svgSrc={twitter} width={40} />
              </a>
              <a href="https://www.youtube.com/whoscored" rel="noopener noreferrer" target="_blank" title="Youtube">
                <Picture altText="youtube icon" className={styles.socialIcon} height={40} svgSrc={youtube} width={40} />
              </a>
            </div>
            <div className={styles.standardLinksContainer} data-testid="general-links">
              <ul className={styles.standardLinksList}>
                {links.map(({ href, title }, idx) => (
                  <li className={styles.standardLinksListItem} key={`${title.toLowerCase()}_${idx}`}>
                    {idx > 0 && <span className={styles.separatorDot}>·</span>}
                    <a className={styles.standardLink} data-testid="general-link" {...formatLinkProperties(href)}>
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.logosWrapper} data-testid="logo-links">
          <a href="https://www.gamstop.co.uk/" rel="noopener noreferrer" target="_blank" title="GamStop">
            <Picture altText="gamstop icon" className={styles.gamStop} height={13} svgSrc={gamstop} width={54} />
          </a>
          <a href="https://www.begambleaware.org/" rel="noopener noreferrer" target="_blank" title="BeGambleAware">
            <Picture
              altText="gamble aware icon"
              className={styles.gambleAware}
              height={22}
              svgSrc={begambleaware}
              width={116}
            />
          </a>
          <a href="https://www.raig.org/" rel="noopener noreferrer" target="_blank" title="Raig">
            <Picture altText="raig icon" className={styles.raig} height={18} svgSrc={raigSvg} width={55} />
          </a>
          <a
            href="https://www.gamblingtherapy.org/en"
            rel="noopener noreferrer"
            target="_blank"
            title="Gambling Therapy"
          >
            <Picture
              altText="gambling therapy icon"
              className={styles.gamblingTherapy}
              height={22}
              svgSrc={gamblingtherapy}
              width={60}
            />
          </a>
        </div>
      </div>
    </section>
  );
};
